export const actionTypes = {
  GET_INFO: 'APP.USER.GET_INFO',
  GET_INFO_SKIP_LOADING: 'APP.USER.GET_INFO.SKIP_LOADING',
  REQUEST_SUCCESS: 'APP.USER.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.USER.REQUEST_FAILURE',
  CLOSE_WRITE_OFF_MESSAGE: 'APP.USER.CLOSE_WRITE_OFF_MESSAGE',
  RESET_IS_PRIMARY_PASSWORD: 'APP.USER.RESET_PRIMARY_PASSWORD',
  SET_TEMPORARY_PASSWORD: 'APP.USER.SET_TEMPORARY_PASSWORD',
  UPDATE_TAX_INFO: 'APP.USER.UPDATE_TAX_INFO',
  GET_INN_CERTIFICATE_CARD_ID: 'APP.USER.GET_INN_CERTIFICATE_CARD_ID',
};

export function getInfo() {
  return {
    type: actionTypes.GET_INFO,
  };
}

export function getInfoSkipLoading() {
  return {
    type: actionTypes.GET_INFO_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function closeWriteOffMessage(key) {
  return {
    type: actionTypes.CLOSE_WRITE_OFF_MESSAGE,
    payload: key,
  };
}

export function resetIsPrimaryPassword() {
  return {
    type: actionTypes.RESET_IS_PRIMARY_PASSWORD,
  };
}

export function updateTaxInfo(taxInfo) {
  return {
    type: actionTypes.UPDATE_TAX_INFO,
    payload: taxInfo,
  };
}
export function getInnCertificateCardId() {
  return {
    type: actionTypes.GET_INN_CERTIFICATE_CARD_ID,
  };
}
